import type { FC, ReactNode } from 'react'
import type { RuleDrawProps } from '@/types'

import { cn } from '@/lib/utils'
import { useReveal } from '@/hooks/use-reveal'

/** A hairline that draws itself in from the left as it enters the viewport. */
export const RuleDraw: FC<RuleDrawProps> = ({ className, delay = 0, tone = 'rule' }): ReactNode => {
    const { ref, shown } = useReveal<HTMLSpanElement>(0)

    return (
        <span
            ref={ref}
            aria-hidden='true'
            data-shown={shown}
            className={cn(
                'fz-rule-draw block h-px w-full',
                tone === 'rule' ? 'bg-fz-rule' : 'bg-fz-rule-on',
                className
            )}
            style={{ transitionDelay: `${delay}s` }}
        />
    )
}
